import { default as QuickLinks } from './QuickLinks';

export { LinkItem } from './QuickLinks';

export default QuickLinks;
